import { useState } from 'react';
import { Col } from 'reactstrap';
import ListadoEmpresas from '../../components/matriculas/grupos/ListadoEmpresas';
import FiltrosFacturación from '../../components/facturas/FiltrosFacturacion';
import RecibosFiltrados from '../../components/facturas/RecibosFiltrados';

const FacturarRecubos = () => {
  const [pageCont, setPageCont] = useState(1);
  const [empresaId, setEmpresaId] = useState('CEDESCA');
  const [formaPago, setFormaPago] = useState('99');
  const [tipoUsuario, setTipoUsuario] = useState('1');
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);

  const [selectedClientes, setSelectedClientes] = useState([]);
  const [selectedImports, setSelectedImports] = useState([]);

  // Total de euros seleccionados
  const euros = selectedImports.reduce((acc, item) => acc + item.value, 0);

  // Número de clientes seleccionados
  const totalClientesSeleccionados = selectedClientes.length;

  const nextPage = () => setPageCont(pageCont + 1);
  const returnPage = () => setPageCont(pageCont - 1);

  return (
    <Col md="12">
      {pageCont === 1 && <ListadoEmpresas setEmpresaId={setEmpresaId} next={nextPage} />}
      {pageCont === 2 && (
        <FiltrosFacturación
          next={nextPage}
          headquarter={empresaId}
          ret={returnPage}
          setSelectedClientes={setSelectedClientes}
          selectedClientes={selectedClientes}
          formaPago={formaPago}
          setFormaPago={setFormaPago}
          tipoUsuario={tipoUsuario}
          setTipoUsuario={setTipoUsuario}
          fechaInicio={fechaInicio}
          setFechaInicio={setFechaInicio}
          fechaFin={fechaFin}
          setFechaFin={setFechaFin}
          euros={euros}
          totalClientesSeleccionados={totalClientesSeleccionados} // <-- nuevo prop
          setSelectedImports={setSelectedImports}
        />
      )}
      {pageCont === 3 && (
        <RecibosFiltrados
          headquarter={empresaId}
          ret={returnPage}
          selectedClientes={selectedClientes}
          fechaFin={fechaFin}
          formaPago={formaPago}
          fechaInicio={fechaInicio}
          tipoUsuario={tipoUsuario}
        />
      )}
    </Col>
  );
};
export default FacturarRecubos;
